<template>
  <Page type="no-header">

      <List />
  </Page>
</template>

<script>
import Page from '@/components/visual/Page'
import List from '@/components/dayprediction/List'

export default {
    components: { Page, List },
    data() {
      return {
      }
    },
}
</script>

<i18n locale="ru" lang="yaml">
  pageTitle: "Прогноз на день"
</i18n>

<i18n locale="en" lang="yaml">
  pageTitle: "Day prediction"
</i18n>
